import { render } from "./AthleteListCard.vue?vue&type=template&id=20add31f&scoped=true"
import script from "./AthleteListCard.vue?vue&type=script&lang=js"
export * from "./AthleteListCard.vue?vue&type=script&lang=js"

import "./AthleteListCard.vue?vue&type=style&index=0&id=20add31f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20add31f"]])

export default __exports__